import type { TaskStatus } from '@/domains/task/enums';
import type { ImageToTextResult } from './create-novelty-check-task-api';

export interface StepDetail<T> {
    content_type: T;
    hide?: boolean;
}


export interface ApiGetTaskDetailResponse<ContentType, CurrentStep = string> {
    task_id: string;
    current_step: CurrentStep;
    task_status: TaskStatus;
    user_input: string;
    input_lang: string;
    /**
     * 翻译后的用户输入
     */
    translation_input?: string;
    /**
     * 任务名称
     */
    title: string;
    step_detail: {
        [step: string]: StepDetail<ContentType>[];
    };
    /**
     * 任务创建时间
     */
    created_at: number;
    /**
     * 任务更新时间
     */
    updated_at: number;
    /**
     * 是否为历史数据
     */
    is_history_data?: boolean;
    wireframeExtractConfig?: {
        enabled: boolean;
        remainingCount: number;
        totalCount: number;
    };
    /**
     * 图片转文本结果
     * @description 当用户上传图片进行识别时，此字段包含识别结果
     */
    image_to_text_result?: ImageToTextResult;
}

export const GetTaskDetail = Symbol('GetTaskDetail');

/**
 * 获取任务状态
 * @param ContentType 任务内容类型
 * @param CurrentStep 当前步骤类型
 */
export interface GetTaskDetail<ContentType, CurrentStep = string> {
    getTaskDetail(taskId: string): Promise<ApiGetTaskDetailResponse<ContentType, CurrentStep>>;
}
